/* eslint-disable */
export default {
  businessApiUrl: "http://localhost:8080/",
  isDemo: true,
  // apiUrl: 'http://localhost:8086',
};
